import React from 'react';
import { InfoIcon } from "@vwfs-bronson/bronson-react";
import copyPng from "../../../images/copy.png";

export default function InfoIconExtended(params: { label: string; }) {

  function copyToClipboard() {
    navigator.clipboard.writeText(params.label);
  }

  return (
    <InfoIcon className="semantic-info" testId="infoIconInvoicesData" tippyProps={{
      appendToBody: true,
    }}>
      {params.label}
      <img src={copyPng} className="copy-icon" onClick={copyToClipboard} />
    </InfoIcon>
  );
}